import type { ReactNode } from 'react'
import { Navigate } from 'react-router'

import { useAuth } from '@/shared/contexts/AuthContext'
import { ui } from '@/shared/strings/ui'

export function RequireJudge({ children }: { children: ReactNode }): React.ReactElement {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-muted-foreground">{ui.common.loading}</div>
      </div>
    )
  }

  // Authenticated but not a judge (admin) — send to admin area
  if (user && user.type !== 'judge') return <Navigate to="/admin" replace />

  // Judge authenticated (from server or cached in IndexedDB) — let them in.
  // Works offline because auth is persisted to IndexedDB.
  if (user) return <>{children}</>

  // No user at all (no cache, no session) — session genuinely expired.
  // Don't send to /login (judges can't use it). Show a clear message.
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="rounded-lg border border-border/30 bg-card p-6 text-center">
        <h1 className="mb-2 text-lg font-semibold text-destructive">{ui.auth.sessionExpired}</h1>
        <p className="text-sm text-muted-foreground">{ui.auth.sessionExpiredMessage}</p>
      </div>
    </div>
  )
}
